import script from "./NavHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavHeader.vue?vue&type=script&setup=true&lang=ts"

import "./NavHeader.vue?vue&type=style&index=0&id=2b5791cc&scoped=true&lang=css"

import exportComponent from "/node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b5791cc"]])

export default __exports__